export interface Stat {
  name: string;
  type: string;
  key: string;
  tooltipText?: string;
  value?: MultiValue | number | string;
}

export interface MultiValue {
  from: number | string;
  to: number | string;
}

export enum QUILLPRODUCTS {
  PARAPHRASER = 'pphr',
  GRAMMAR_CHECKER = 'grmr',
  PLAGIARISM_CHECKER = 'plac',
}
